import { useTranslation } from "react-i18next";
import image from '../../img/TradeTerminal/plate.png';

const Plate = () => {
    const { t } = useTranslation();
    return (
        <section className="relative overflow-hidden open-sans bg-[#15318D] mt-[90px] md:mt-0">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px] md:py-[100px] pt-[30px] pb-0">
                <div className="md:grid items-center flex flex-col grid-cols-2 gap-0 md:gap-[40px] xl:gap-[95px]">
                    <div className="relative z-10">
                        <h2 className="text-[#fff] font-[700] text-[28px]">
                            {t('terminal.plate.title')}
                        </h2>
                        <div className="sm:text-[16px] text-[14px] text-[#FFF] font-[300] mt-[25px] md:mt-[30px]">
                            <p>
                                {t('terminal.plate.text_01')}
                            </p>
                            <p className="mt-[13px] md:mt-[15px]">
                                {t('terminal.plate.text_02')}
                            </p>
                        </div>
                    </div>
                    <div className="relative z-0 flex justify-center items-center md:mt-0 mt-[35px] h-[100%]">
                        <img className="md:absolute relative left-0 right-0 mx-auto md:bottom-[-100px] w-[100%] md:max-w-[299px] sm:max-w-[240px] max-w-[215px]" src={image} alt='' />
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Plate;
